import { trace } from 'owa-trace';
import { registerExternalSignoutCleanup } from 'owa-msaljs';

export type SignoutPromiseCallback = () => Promise<any>;

export const signoutPromisesCallbacks: SignoutPromiseCallback[] = [];

let isRegistered = false;

// Register our cleanup function with owa-msaljs so Activity Timeout can use it
async function owaSignoutCleanup(): Promise<void> {
    const cleanupPromises: Promise<any>[] = executeSignoutPromises();
    await Promise.all(cleanupPromises).catch(e => {
        trace.info('OwaSignoutCleanupError: ' + e);
    });
}

export function addSignoutPromise(callback: SignoutPromiseCallback): void {
    // Register with owa-msaljs on first use to avoid module-scope side effects
    if (!isRegistered) {
        registerExternalSignoutCleanup(owaSignoutCleanup);
        isRegistered = true;
    }
    signoutPromisesCallbacks.push(callback);
}

export function executeSignoutPromises(): Promise<any>[] {
    return signoutPromisesCallbacks.map(cb => cb());
}
